export default {
  state: {
    data: {}
  }
};
